import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { SettingService } from '../../services/setting/setting.service';
import * as firebase from 'firebase/app';
import 'firebase/firestore';

@Component({
  selector: 'profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  constructor(
    public auth: AuthService,
    public setting: SettingService,
  ) { }

  ngOnInit(): void {
  }

  syncSignatureNow(): void {
    const user = firebase.auth().currentUser;

    if (user) {
      // Create a sync request in a separate subcollection to avoid infinite loops
      firebase.firestore().collection('users').doc(user.uid).collection('gmailSyncRequest').doc('sync').set({
        status: 'pending',
        requestedAt: firebase.firestore.FieldValue.serverTimestamp(),
      }).then(() => {
        console.log('Signature sync requested');
      }).catch(error => {
        console.error('Error requesting signature sync:', error);
      });
    }
  }

  logout() {
    this.auth.logout();
  }
}
